import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TestQueryService } from "../../test-query.service";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.less']
})
export class RegisterComponent implements OnInit {
  validateForm: FormGroup;
  password:any;
  username:any;
  surePassword:any;
  nowIp: any;

  submit(): void {
    
    let dbdata = {
      headers: new HttpHeaders({'Content-Type' : 'application/json'})
    }
    if(this.surePassword==this.password){
      let data = {
        userName:this.username,
        password:this.password
      }
      let api = this.nowIp+':8809/login/save/';
      this.http.post(api,data,dbdata).subscribe((res:any)=>{
        if(res==200){
          this.router.navigate(['']);
        }
      })
    }else{
      this.createBasicMessage("两次密码不一致！");
    }
  }
  // 提示框
  createBasicMessage(title:any): void {
    this.nzMessageService.info(title);
  }

  constructor(
    private fb: FormBuilder,
    public router: Router,
    public http:HttpClient,
    private nzMessageService: NzMessageService,
    public ml:TestQueryService
    ) {}

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      userName: [null, [Validators.required]],
      password: [null, [Validators.required]],
      remember: [true]
    });

    
    
    const xhr = new XMLHttpRequest();
    const url = 'assets/server.json'
    xhr.open('GET',url,false)
    xhr.send()
    if (xhr.status == 200) {
      if(xhr.response!=null){
        this.nowIp = JSON.parse(xhr.response).serverAPI
      }
    }
  }
}
